import React from "react";

/**
 * LocalLawFinder shield mark.
 * - Beige tile background that matches the cream palette (--accent surface).
 * - Dark outer shield + gold inner shield with a clean cross.
 * - Pure SVG, scales cleanly at any size, dark-mode friendly.
 */
export default function LocalLawFinderLogo({ className = "", size = 44 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 248 248"
            width={size}
            height={size}
            role="img"
            aria-label="LocalLawFinder logo"
            className={className}
            data-testid="lll-logo">
            {/* Tile background */}
            <rect x="0" y="0" width="248" height="248" rx="28" fill="hsl(var(--accent))" />
            <rect x="0" y="0" width="248" height="248" rx="28" fill="none" stroke="hsl(var(--border))" strokeWidth="3" />
            {/* Outer shield (dark) */}
            <path d="M124 46L182 80V146C182 192 156 226 124 240C92 226 66 192 66 146V80L124 46Z" fill="hsl(var(--foreground))" />
            {/* Inner shield (gold) */}
            <path d="M124 62L168 88V145C168 180 149 207 124 218C99 207 80 180 80 145V88L124 62Z" fill="#B38A3A" />
            {/* Cross */}
            <path d="M124 92V178" stroke="hsl(var(--accent))" strokeWidth="9" strokeLinecap="round" />
            <path d="M94 122H154" stroke="hsl(var(--accent))" strokeWidth="9" strokeLinecap="round" />
            {/* Subtle base curve */}
            <path d="M92 184C103 195 114 200 124 200C134 200 145 195 156 184" stroke="hsl(var(--accent))" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.65" />
        </svg>
    );
}
